export const types = {
    SET_FRAME: "SET_FRAME",
  }